$(document).ready(function($) {
  $(document).scrollTop(1);
         var provincesF = $(".mobile-bypass-zones").attr("Bypass-Zone");
      var mobileEnableBypass = $(".mobile-bypass-zones").attr("data-enable-mobile-bypass");
         var desktopCheck = $(".dsktop-check-jtpl").attr("dsktop-postalCodes");
        var windowsize = $(window).width();

   

  
          jQuery.getJSON('/cart.js', function(cart) {
          //console.log(cart.attributes)
          // if ($(".location-menu").hasClass("addcity")) 
           var cities = getCookie("jtpl-cities");
          var url = window.location.href;
           if (cities == "" && url.indexOf("myshopify.com") == -1 ){



             $.ajax({
        type: "POST",
        url: '/cart/clear.js',
        data: '',
        dataType: 'json',
        success: function() {
          console.log("successsssss");
        },
        error: function(XMLHttpRequest, textStatus) {
         console.log(XMLHttpRequest);
        }
      });
            $.ajax({
              url: 'https://ipapi.co/json/?key=6DXobwykfgUZVF9wmnSo3Vrt4ho3gPUCm2gjUj2MoFZIgHring',
              dataType: 'json',
              type: 'GET',
              complete: function(data) {
               var crrnt_city = data.responseJSON.city;
                var crrnt_region = data.responseJSON.region;
                var crrnt_code = data.responseJSON.postal;
              var data = {
              attributes: {
                  postalCode: crrnt_code,
                  postalCity: data.responseJSON.city,
                  postalRegion: data.responseJSON.region,
              }
          };
          if (mobileEnableBypass == 'true' && provincesF.includes(crrnt_region) && windowsize < 768) {
               var data = {
              attributes: {
                  postalCode: crrnt_code,
                  postalCity: "Laval",
                  postalRegion: "New Brunswick",
              }
            };
                 }
             
              var cities = getCookie("jtpl-cities");
              if (cities != "") {
              } else {
              setCookie("jtpl-cities", crrnt_city);
              }
                var region = getCookie("jtpl-region");
              if (region != "") {
              } else {
              setCookie("jtpl-region", crrnt_region);
              } 
              var postalCodeCurrnt = getCookie("jtpl-postal");
              if (postalCodeCurrnt != "") {
              } else {
              setCookie("jtpl-postal", crrnt_code);
              } 
             $.ajax({
              url: '/cart/update.js',
              dataType: 'json',
              contentType: 'application/json',
              type: 'POST',
              data: JSON.stringify(data),
              complete: function(xhr) {

                  console.log(xhr.responseJSON);
                  location.reload();
              setTimeout(function(){
               $(".coll-prices-jtpl span").attr("style","visibility:visible !important;");
                $(".coll-prices-jtpl").removeClass("animated-background");
            },500);
               
                  
              },
              error: function(xhr) {
                  console.log(xhr.responseText);
              },
          });
                
                 
              },
              error: function(xhr) {
                  console.log(xhr.responseText);
              },
          });
          }else{
            setTimeout(function(){
               $(".coll-prices-jtpl span").attr("style","visibility:visible !important;");
                $(".coll-prices-jtpl").removeClass("animated-background");
            },500);
          }
 });
    $(document).ready(function($) {
    $('.postal-code-form').submit(function(e){
          e.preventDefault();
          var value = $(this).find('.postal-code-input').val();
          // var city_name = $(this).find('.postal-city-input').val();
          // var region = $(this).find('.postal-region-input').val();
          var data = {
              attributes: {
                  postalCode: value,
                //   postalCity: city_name,
                // postalRegion: region,
              }
          };
          $.ajax({
              url: '/cart/update.js',
              dataType: 'json',
              contentType: 'application/json',
              type: 'POST',
              data: JSON.stringify(data),
              complete: function(xhr) {
                
                  console.log(xhr.responseJSON);
                  location.reload();
              },
              error: function(xhr) {
                  console.log(xhr.responseText);
              },
          });
      });
      
 $('.popupCloseButton').click(function(e){
    var currntPostCode = getCookie("jtpl-postal");
    setCookiePopup("popup-postal-jtpl", "");
     $("body").removeClass("postal-popup-overlay"); 
         $(".hover_background").hide();
      });
      
  $('.postal-code-form-jtpl').submit(function(e){
    e.preventDefault();
    var newPostalCode =  $(this).find("input.postal-code-input").val();
        var data = {
              attributes: {
                  popupPostalCode: newPostalCode,
              }
          };
          $.ajax({
              url: '/cart/update.js',
              dataType: 'json',
              contentType: 'application/json',
              type: 'POST',
              data: JSON.stringify(data),
              complete: function(xhr) {
                 setCookiePopup("popup-postal-jtpl", newPostalCode);
                  console.log(xhr.responseJSON);
                  location.reload();
              setTimeout(function(){
               $(".coll-prices-jtpl span").attr("style","visibility:visible !important;");
                $(".coll-prices-jtpl").removeClass("animated-background");
            },500);
               
                  
              },
              error: function(xhr) {
                  console.log(xhr.responseText);
              },
          });

      });

      
      $('.change-postal-code').click(function(e){
          e.preventDefault();
        changePostalDetails();
      });
 var handleCancelSearch = '';
document.querySelector('.t4s-site-nav__search .t4s-d-lg-none').addEventListener('click', function() {
   $('#t4s-search-hidden .t4s-mini-search__input').trigger("click");
  document.querySelector('#t4s-search-hidden .t4s-mini-search__input').click();
  
    document.querySelector('#t4s-search-hidden').style.display = 'none';
    
    handleCancelSearch = setInterval(getCancel, 100);
});

function getCancel() {
  if(document.querySelectorAll('.cloud-search-mobile .cloud-search-mobile__cancel').length > 0){
    var cancelButtons = document.querySelectorAll('.cloud-search-mobile .cloud-search-mobile__cancel');
    cancelButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            document.querySelector('.t4s-drawer__close').click();
            document.body.classList.remove('is--opend-drawer', 't4s-lock-scroll');
        });
    });
       var backdropButtons = document.querySelectorAll('.cloud-search-mobile-backdrop');
    backdropButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            document.querySelector('.t4s-drawer__close').click();
            document.body.classList.remove('is--opend-drawer', 't4s-lock-scroll');
        });
    });
    clearInterval(handleCancelSearch);
  }
}

 
      $('.tab_title_block a').click(function(e){
          e.preventDefault();
      var dataTargetVal =   $(this).attr("href");
        $(".tab_title_block").removeClass("active");
        $(this).parent(".tab_title_block").addClass("active");
        $(".panel.entry-content.sp-tab.des_mb_2.des_style_").hide();
         $(dataTargetVal).addClass("active");
        $(dataTargetVal).show();
        
        
});

 });//document ready

       

          
/*
  $("body").on("click",".t4s-site-nav__search a.t4s-d-lg-none",function(){
    $('#t4s-search-hidden').attr("style","display:none");
    $('.t4s-mini-search__input').trigger("focus");    
    $('.t4s-mini-search__input').trigger("click");    
    handleCancelSearch = setInterval(getCancel, 100);
  });

  function getCancel(){
      if($('.cloud-search-mobile .cloud-search-mobile__cancel').length > 0){
         $("body").on("click",".cloud-search-mobile .cloud-search-mobile__cancel",function(){
          $('body').removeClass("is--opend-drawer");
          $('body').removeClass("t4s-lock-scroll");
          $('.t4s-drawer__close').trigger("click");    
          handleCancelSearch = setInterval(getCancel, 100);
          });        
          clearInterval(handleCancelSearch);
          }
    }
    */
     
  var handleCancelSearch = '';
document.querySelector('.t4s-site-nav__search .t4s-d-lg-none').addEventListener('click', function() {
   $('#t4s-search-hidden .t4s-mini-search__input').trigger("click");
  document.querySelector('#t4s-search-hidden .t4s-mini-search__input').click();
  
    document.querySelector('#t4s-search-hidden').style.display = 'none';
    
    handleCancelSearch = setInterval(getCancel, 100);
});

function getCancel() {
  if(document.querySelectorAll('.cloud-search-mobile .cloud-search-mobile__cancel').length > 0){
    var cancelButtons = document.querySelectorAll('.cloud-search-mobile .cloud-search-mobile__cancel');
    cancelButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            document.querySelector('.t4s-drawer__close').click();
            document.body.classList.remove('is--opend-drawer', 't4s-lock-scroll');
        });
    });
     var backdropButtons = document.querySelectorAll('.cloud-search-mobile-backdrop');
    backdropButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            document.querySelector('.t4s-drawer__close').click();
            document.body.classList.remove('is--opend-drawer', 't4s-lock-scroll');
        });
    });
    clearInterval(handleCancelSearch);
  }
}
  var popupCookiee = getCookie("popup-postal-jtpl")
  var newPostalCode =  $(".postal-code-form").find("input.postal-code-input").val();
  var url = window.location.href;
   if(popupCookiee == '' && url.indexOf("myshopify.com") == -1){
   
          var data = {
              attributes: {
                  popupPostalCode: '',
              }
          };
          $.ajax({
              url: '/cart/update.js',
              dataType: 'json',
              contentType: 'application/json',
              type: 'POST',
              data: JSON.stringify(data),
              complete: function(xhr) {
                 setCookiePopup("popup-postal-jtpl", newPostalCode);
                  location.reload();
              setTimeout(function(){
               $(".coll-prices-jtpl span").attr("style","visibility:visible !important;");
                $(".coll-prices-jtpl").removeClass("animated-background");
            },500);
               
                  
              },
              error: function(xhr) {
                  console.log(xhr.responseText);
              },
          });
   }

});
if($("body").hasClass("template-product")){
   setTimeout(function(){
               $(".coll-prices-jtpl span").attr("style","visibility:visible !important;");
                $(".coll-prices-jtpl").removeClass("animated-background");
            },3000);
}

function changePostalDetails(){
          var data = {
              attributes: {
                  postalCode: '',
                  region: '',
              }
          };
          $.ajax({
              url: '/cart/update.js',
              dataType: 'json',
              contentType: 'application/json',
              type: 'POST',
              data: JSON.stringify(data),
              complete: function(xhr) {
                  location.reload();
              },
              error: function(xhr) {
                  console.log(xhr.responseText);
              },
          });
  }
    /**cookies */
function setCookie(cname,cvalue) {
  var d = new Date();
  var minutes = $(".location-menu").attr("cooki-jtpl");
  d.setTime(d.getTime() + (minutes * 60 * 1000));
  console.log(d.toUTCString());
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function setCookiePopup(cname,cvalue) {
  var d = new Date();
  var minutes = $(".location-menu").attr("cooki-popup-jtpl");
  d.setTime(d.getTime() + (minutes * 60 * 1000));
  console.log(d.toUTCString());
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}